
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/originals",
      function () {
        return require("private-next-pages/originals/index.tsx");
      }
    ]);
  